enum Kind {
  TRACKS = 'TRACKS',
  COLLECTIONS = 'COLLECTIONS',
  USERS = 'USERS',
  TRACK_ROUTES = 'TRACK_ROUTES'
}

export default Kind
